import {
  MenuOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { Drawer, Menu } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const HeaderFile = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 770);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const items = [
    { key: "/", label: "Home" },
    {
      key: "blogs",
      label: (
        <a
          href="https://blog.rucksackdiaries.com/blogs"
          rel="noopener noreferrer"
        >
          Blogs
        </a>
      ),
    },
    {
      key: "shops",
      label: (
        <a
          href="https://blog.rucksackdiaries.com/shop"
          rel="noopener noreferrer"
        >
          Shop
        </a>
      ),
    },
    {
      key: "shops",
      label: (
        <a
          href="https://blog.rucksackdiaries.com/trips-events"
          rel="noopener noreferrer"
        >
          Trips & Events
        </a>
      ),
    },
    { key: "/work", label: "Partners" },
    { key: "/about", label: "About" },
    { key: "/contact", label: "Contact" },
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 770);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleDrawer = () => {
    setDrawerOpen((prev) => !prev);
  };

  const onMenuClick = ({ key }) => {
    if (key.startsWith("/")) {
      navigate(key);
    }
    setDrawerOpen(false);
  };

  return (
    <div className="header-style">
      {/* Logo */}
      <div className="center">
        <img
          src="../logo.png"
          alt="Logo"
          style={{
            height: isMobile ? "25px" : "30px",
            cursor: "pointer",
          }}
          onClick={() => navigate("/")}
        />
      </div>

      {/* RIGHT SIDE ICONS (Mobile) */}
      {isMobile && (
        <div className="mobile-icons">
          {/* Cart Icon */}
          <a
            href="https://blog.rucksackdiaries.com/shop"
            rel="noopener noreferrer"
          >
            <img
              src="../cart.png"
              alt="cart"
              className="cart-icon"
            />
          </a>

          {/* Menu Icon */}
          {drawerOpen ? (
            <CloseOutlined
              className="menu-icon"
              onClick={toggleDrawer}
            />
          ) : (
            <MenuOutlined
              className="menu-icon"
              onClick={toggleDrawer}
            />
          )}
        </div>
      )}

      {/* Drawer */}
      <Drawer
        placement="left"
        width={260}
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        closable={false}
      >
        <Menu
          mode="vertical"
          items={items}
          selectedKeys={[location.pathname]}
          onClick={onMenuClick}
          style={{ borderRight: "none" }}
        />
      </Drawer>

      {/* Desktop Menu */}
      {!isMobile && (
        <div className="menu-style">
          <Menu
            theme="light"
            mode="horizontal"
            items={[
              ...items,
              {
                key: "cart",
                label: (
                  <a
                    href="https://blog.rucksackdiaries.com/shop"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="../cart.png"
                      alt="cart"
                      className="cart-icon"
                    />
                  </a>
                ),
              },
            ]}
            selectedKeys={[location.pathname]}
            onClick={({ key }) => navigate(key)}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              borderBottom: "none",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default HeaderFile;